export const greenlistWords = [
  "accumulate",
  "accumulated",
  "accumulates",
  "accumulating",
  "accumulation",
  "accumulative",
  "accumulator",
  "acumen",
  "acuminate",
  "acuminated",
  "acumination",
  "adventitious",
  "alongshore",
  "altitude",
  "altitudinal",
  "altitudinous",
  "ambassador",
  "ambassadorship",
  "analysis",
  "anchored",
  "anticompetitive",
  "antithesis",
  "antithetical",
  "appetite",
  "appetitive",
  "aptitude",
  "assemblage",
  "assembler",
  "assent",
  "assert",
  "assertion",
  "assertive",
  "assertivenesses",
  "assess",
  "assessment",
  "assets",
  "assign",
  "assignabilities",
  "assignment",
  "assimilate",
  "assimilationism",
  "assimilationist",
  "assist",
  "assistance",
  "assistant",
  "assistive",
  "associate",
  "assort",
  "assortment",
  "assuagement",
  "assumably",
  "assume",
  "assumed",
  "assumes",
  "assuming",
  "assumingly",
  "assumption",
  "assumptions",
  "assumptive",
  "assurance",
  "assure",
  "assured",
  "attitude",
  "attitudes",
  "authored",
  "backshore",
  "bass",
  "bassist",
  "biomass",
  "butt",
  "bypass",
  "cassandra",
  "casserole",
  "cassia",
  "chore",
  "choreograph",
  "choreographer",
  "choreography",
  "chores",
  "chunky",
  "circumstance",
  "circumstances",
  "circumstantial",
  "circumvent",
  "circumvented",
  "class",
  "classes",
  "classic",
  "classical",
  "classifications",
  "classified",
  "classmate",
  "classmates",
  "classroom",
  "classy",
  "cockpit",
  "cocktail",
  "cocoon",
  "compass",
  "compassion",
  "compassionate",
  "compassionately",
  "compassionateness",
  "compassionless",
  "competition",
  "competitive",
  "competitiveness",
  "competitor",
  "competitors",
  "constituent",
  "constituents",
  "constitute",
  "constituted",
  "constitutes",
  "constituting",
  "constitution",
  "constitutional",
  "constitutionally",
  "constitutive",
  "correctitude",
  "cucumber",
  "cumulate",
  "cumulation",
  "cumulative",
  "cutlass",
  "dassie",
  "declassed",
  "declassification",
  "declassify",
  "decumbent",
  "disassociations",
  "disembarrassing",
  "disencumber",
  "disencumbered",
  "dispassionate",
  "dispassionately",
  "document",
  "documentary",
  "documentation",
  "documented",
  "documenting",
  "documents",
  "doorknob",
  "eggshell",
  "embarrass",
  "embarrassment",
  "embassy",
  "encompass",
  "entities",
  "entitle",
  "entitled",
  "entitlement",
  "entity",
  "exactitude",
  "farseeing",
  "fiberglass",
  "fortitude",
  "fortitudinous",
  "gassed",
  "gassy",
  "glass",
  "glassblower",
  "glasses",
  "glasshouse",
  "glasslike",
  "glassmaker",
  "glassware",
  "glassy",
  "godzilla",
  "grass",
  "grasshopper",
  "grassland",
  "grassroots",
  "grassy",
  "gratitude",
  "has hit",
  "hassle",
  "hell",
  "helloooo",
  "hellooo",
  "hellacious",
  "hello",
  "hit",
  "identities",
  "identity",
  "impassive",
  "impassivenesses",
  "inaptitude",
  "incertitude",
  "ingratitude",
  "institute",
  "instituted",
  "instituter",
  "instituting",
  "institution",
  "institutional",
  "is hit",
  "japan",
  "japanese",
  "lakeshore",
  "manuscript",
  "massage",
  "masses",
  "massif",
  "massive",
  "multitalented",
  "multitask",
  "multitasker",
  "multitasking",
  "multitool",
  "multitude",
  "nearshore",
  "noble",
  "nobody",
  "nutshell",
  "offshore",
  "onshore",
  "overassessments",
  "overclassifying",
  "Pass",
  "passage",
  "passageway",
  "passed",
  "passee",
  "passenger",
  "passengers",
  "passer",
  "passerby",
  "passersby",
  "passes",
  "passim",
  "passing",
  "passion",
  "passionate",
  "passionately",
  "passionateness",
  "passionless",
  "passions",
  "passive",
  "passively",
  "passiveness",
  "passivity",
  "passkey",
  "passport",
  "peacock",
  "petite",
  "phosphorescence",
  "phosphorescent",
  "plexiglass",
  "potassium",
  "psychoanalysis",
  "puberty",
  "quantitate",
  "quantitation",
  "quantitative",
  "quantitatively",
  "quantities",
  "quantity",
  "raccoon",
  "reassert",
  "reassertion",
  "reassess",
  "reassessment",
  "reassign",
  "reassume",
  "reassurance",
  "reassure",
  "reassured",
  "reassuring",
  "reassuringly",
  "reconstitute",
  "reconstituted",
  "reconstitution",
  "rehearse",
  "repass",
  "repetition",
  "repetitious",
  "repetitive",
  "sass",
  "sassiness",
  "sassy",
  "seashell",
  "seashore",
  "shell",
  "shellac",
  "shellacking",
  "shelled",
  "shellfish",
  "shore",
  "shoreline",
  "shoreside",
  "spac",
  "space",
  "spacey",
  "stitch",
  "subtitle",
  "succumb",
  "succumbed",
  "succumbing",
  "superstition",
  "superstitious",
  "surpass",
  "surpassing",
  "timepass",
  "titan",
  "titanic",
  "title",
  "titled",
  "tortoiseshell",
  "trespass",
  "trespasser",
  "trespassing",
  "tycoon",
  "unassertive",
  "unassisted",
  "unassociated",
  "unassuming",
  "unassumingness",
  "unclassified",
  "unclassy",
  "uncompassionate",
  "underclass",
  "undocumented",
  "unembarrassed",
  "unencumbered",
  "unimpassioned",
  "unpassionate",
  "unrehearsed",
  "unsurpassable",
  "untitled",
  "vastitude",
  "was hit",
  "wassup",
];
